import { useLang } from "@/lib/lang";
import { IMG, WHATSAPP_URL } from "@/lib/constants";
import { Star, Sparkles } from "lucide-react";

export default function Hero({ onOpenLead }) {
  const { t, lang } = useLang();
  return (
    <section className="relative overflow-hidden">
      {/* Big yellow blob backdrop */}
      <div className="absolute -top-32 -right-40 w-[560px] h-[560px] rounded-full opacity-70 pointer-events-none" style={{ background: "var(--yellow)" }} />
      <div className="absolute top-40 -left-32 w-72 h-72 rounded-full opacity-40 pointer-events-none" style={{ background: "var(--yellow-soft)" }} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-12 md:pt-20 pb-16 md:pb-28 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <span data-testid="hero-eyebrow" className="tape-badge fade-up">
            <Sparkles size={12} /> {t.hero.eyebrow}
          </span>
          <h1 className={`mt-6 font-display leading-[0.95] text-5xl md:text-7xl fade-up d1 ${lang === "hi" ? "font-hindi" : ""}`} style={{ color: "var(--primary)" }}>
            {t.hero.title_line_1}
            <br />
            <span style={{ color: "var(--red)" }}>{t.hero.title_line_2}</span>
          </h1>
          <div className="mt-4 inline-block px-3 py-1 rounded font-display text-xl md:text-2xl fade-up d1" style={{ background: "var(--primary)", color: "var(--yellow)" }}>
            {t.hero.tagline}
          </div>
          <p className="mt-6 text-lg md:text-xl max-w-xl fade-up d2" style={{ color: "var(--text-secondary)" }}>
            {t.hero.sub}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3 fade-up d3">
            <button data-testid="hero-book-btn" onClick={onOpenLead} className="btn-primary">
              {t.hero.cta_primary}
            </button>
            <a data-testid="hero-plans-link" href="#plans" className="btn-ghost">
              {t.hero.cta_secondary}
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-8 fade-up d4">
            <div>
              <div className="font-display text-4xl" style={{ color: "var(--primary)" }}>{t.hero.trust_years}</div>
              <div className="text-xs uppercase tracking-widest mt-1 font-semibold" style={{ color: "var(--text-secondary)" }}>{t.hero.trust_years_sub}</div>
            </div>
            <div className="h-10 w-px" style={{ background: "var(--border-strong)" }} />
            <div>
              <div className="flex items-center gap-1 font-display text-4xl" style={{ color: "var(--primary)" }}>
                {t.hero.trust_rating} <Star size={22} fill="#FBC531" stroke="#14142B" strokeWidth={1.5} />
              </div>
              <div className="text-xs uppercase tracking-widest mt-1 font-semibold" style={{ color: "var(--text-secondary)" }}>{t.hero.trust_rating_sub}</div>
            </div>
          </div>
        </div>

        {/* Collage */}
        <div className="lg:col-span-5 relative h-[440px] md:h-[560px] fade-up d2">
          <div className="absolute top-0 right-0 w-[82%] h-[88%] rounded-[32px] overflow-hidden shadow-2xl border-4" style={{ borderColor: "var(--primary)" }}>
            <img
              src={IMG.dietitian}
              alt="Manthan Sharma — Dietitian"
              className="w-full h-full object-cover"
              style={{ objectPosition: "50% 30%" }}
            />
          </div>
          <div className="absolute bottom-2 left-0 w-[38%] h-[34%] rounded-[24px] overflow-hidden shadow-2xl border-4" style={{ borderColor: "var(--yellow)" }}>
            <img src={IMG.food} alt="Healthy food bowl" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-3 right-4 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-xl" style={{ background: "var(--bg)", border: "2px solid var(--primary)" }}>
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "#25D366", color: "white" }}>
              <svg viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M16 4C9.4 4 4 9.4 4 16c0 2.1.5 4.1 1.5 5.8L4 28l6.3-1.6A11.9 11.9 0 0 0 16 28c6.6 0 12-5.4 12-12S22.6 4 16 4z"/></svg>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest font-bold" style={{ color: "var(--text-secondary)" }}>WhatsApp</div>
              <a href={WHATSAPP_URL} className="font-bold text-sm" style={{ color: "var(--primary)" }}>+1 437-557-1041</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
